import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import AuthModal from "./AuthModal";
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const { isAuthenticated } = useAuth();
  const { cartItems, addToCart, updateQuantity, removeFromCart } = useCart();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const cartItem = cartItems.find((item) => item.id === product.id);
  const quantity = cartItem ? cartItem.quantity : 0;

  const handleAdd = () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      return;
    }
    addToCart(product);
  };

  const handleIncrease = () => updateQuantity(product.id, quantity + 1);
  const handleDecrease = () => {
    if (quantity === 1) removeFromCart(product.id);
    else updateQuantity(product.id, quantity - 1);
  };

  return (
    <>
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}

      <div className="product-card">
        <div className="product-card-image-wrap">
          <img
            src={product.image}
            alt={product.name}
            className="product-card-image"
          />
        </div>
        <div className="product-card-info">
          <h3 className="product-card-name">{product.name}</h3>
          {product.serving && (
            <p className="product-card-serving">{product.serving}</p>
          )}
          {product.size && (
            <p className="product-card-serving">{product.size}</p>
          )}
          {product.sizeToggle}
          <p className="product-card-price">₹{product.price}</p>

          {quantity === 0 ? (
            <button className="product-card-btn" onClick={handleAdd}>
              Add to Cart
            </button>
          ) : (
            <div className="qty-control">
              <button className="qty-btn" onClick={handleDecrease}>−</button>
              <span className="qty-value">{quantity}</span>
              <button className="qty-btn" onClick={handleIncrease}>+</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductCard;
